import { FC } from "react"
import classNames from "classnames"
import { Icon, IconColor } from "@/components/shared/Icon"
import Tooltip from "@/components/shared/Tooltip"

interface ActionsProps {
   isEditMode: boolean
   isDisabled: boolean
   onDelete: () => void
   onSave: () => void
   addFacility: () => void
   addUser: () => void
   onEditMode: () => void
   cancel: () => void
   showAddFacility?: boolean
   showAddUser?: boolean
   isFormValid?: boolean
}

const Actions: FC<ActionsProps> = ({
   isEditMode,
   isDisabled,
   onDelete,
   onSave,
   addFacility,
   addUser,
   onEditMode,
   cancel,
   showAddFacility = true,
   showAddUser = true,
   isFormValid = true,
}) => {
   return (
      <span
         className={classNames("customers-facilities-table__actions", {
            "customers-facilities-table__actions--disabled": isDisabled,
         })}
      >
         {isEditMode ? (
            <>
               <Tooltip
                  key="cancel-tooltip"
                  content="Cancel"
               >
                  <Icon
                     name="cross"
                     size="16px"
                     color={IconColor.HONOLULU_BLUE}
                     onClick={() => cancel()}
                  />
               </Tooltip>
               <Tooltip
                  key="delete-tooltip"
                  content="Delete"
               >
                  <Icon
                     name="trashBin"
                     size="16px"
                     color={IconColor.CERISE}
                     onClick={() => onDelete()}
                  />
               </Tooltip>
               {showAddFacility && (
                  <Tooltip
                     key="add-facility-tooltip"
                     content="Add Facility"
                  >
                     <Icon
                        name="addFacility"
                        size="16px"
                        color={IconColor.HONOLULU_BLUE}
                        onClick={() => addFacility()}
                     />
                  </Tooltip>
               )}
               {showAddUser && (
                  <Tooltip
                     key="add-user-tooltip"
                     content="Invite User"
                  >
                     <Icon
                        name="addUser"
                        size="16px"
                        color={IconColor.HONOLULU_BLUE}
                        onClick={() => addUser()}
                     />
                  </Tooltip>
               )}
               <Tooltip
                  key="save-tooltip"
                  content="Save"
               >
                  <Icon
                     disabled={!isFormValid}
                     name="save"
                     size="16px"
                     color={IconColor.HONOLULU_BLUE}
                     onClick={() => onSave()}
                  />
               </Tooltip>
            </>
         ) : (
            <Tooltip
               key="edit-tooltip"
               content="Edit"
            >
               <Icon
                  name="edit"
                  size="16px"
                  color={IconColor.HONOLULU_BLUE}
                  onClick={() => onEditMode()}
               />
            </Tooltip>
         )}
      </span>
   )
}

export default Actions
